import { Component, inject } from '@angular/core';

import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { AdminButtonComponent } from '../../admin-button/admin-button.component';

@Component({
  selector: 'ui-toggle-switch-modal',
  imports: [AdminButtonComponent],
  templateUrl: './toggle-switch-modal.component.html',
})
export class ToggleSwitchModalComponent {
  dialogRef = inject(DialogRef);
  data = inject<{
    message: string;
  }>(DIALOG_DATA);

  handleConfirmed() {
    this.dialogRef.close({ confirmed: true });
  }
}
